// frame: h1EpS @ ui/dogdisk-user.pen
// spec: docs/ui/user-page-flows.md §2.7 h1EpS 页面-500

import { ErrorPageView } from './_view'

export function ServerErrorPage() {
  return (
    <ErrorPageView
      frameId="h1EpS"
      backBtnTestId="zvt5C"
      homeBtnTestId="hVpdT"
      code="500"
      title="服务器错误"
      desc="服务器遇到了一些问题,请稍后再试"
    />
  )
}
